import { DateTime } from "luxon";
import {Location} from "./locations"
import { Job } from "./job";
import { Plan } from "./plan";
import { MasterPlan } from "./master-plan";
import { Change } from "./change";

export class LocationUpdateNotification {
    tenantId! : string;
    createdAt! : string;
    locationId! : string;
    locationName! : string;
    jobId? : string;
    jobName? : string;
    planId! : string;
    planName! : string;
    planContainerId! : string;
    planContainerName! : string;
    changes? : Change;
}
